module.exports = __webpack_public_path__ + "static/bane-symbol-DND3_FnP-7cd508b608d835a0b02a81ad2e2fdc06.webp";